module.exports = __webpack_public_path__ + "static/media/sposob-na-nude.17639cba.jpg";